import { OrganizationList, ParsedOrganizationList } from './utils';

export enum OrganizationsEnum {
  GET_ORGANISATION_LIST = 'organizationlist/get',
}

export interface BaseOrganizationList {
  err_code: number;
  success: boolean;
  filtered: string;
  page: number;
  limit: number;
  token: string;
}

export interface OrganizationListData extends BaseOrganizationList {
  data: OrganizationList;
}

export interface PromiseOrganizationListData extends BaseOrganizationList {
  data: ParsedOrganizationList;
}



// WEBPACK FOOTER //
// ./src/services/api/organizations/types.ts